(ns org.bluebird
  (:require ["bluebird" :as bb]))

(js/goog.exportSymbol "Promise" bb)
